import settings from '../conf/settings';

/* eslint no-unused-vars: "off" */
(function(){
  // loading images here that are referenced in program configs so that they get included in the webpack build and uploaded to S3 during the Travis build
  const jetblueHeaderLogo = require('../assets/images/jetblue-logo-white.svg');
  const jetbluePaywallLogo = require('../assets/images/true-blue-blue-on-white.jpg');
  const helpIcon = require('../assets/images/circle_questionmark.png');
  const jetblueLoadingImg = require('../assets/images/loading-page-image-jetblue.svg');
  const chameleonConsumerHeaderLogo = require('../assets/images/chameleon-consumer-header-horizontal.svg');
  const chameleonConsumerHeaderLogoPng = require('../assets/images/chameleon-consumer-header-horizontal.png');
  const chameleonAirlinesHeaderLogo = require('../assets/images/chameleon-airlines-header.png');
  const jetblueFavicon = require('../assets/images/jetblue-favicon.ico');
  const chameleonFavicon = require('../assets/images/chameleon-favicon.ico');
  const digitalPayFavicon = require('../assets/images/dp-favicon.ico');
  const advancedDisposalHeaderLogo = require('../assets/images/advanced-disposal-header.png');
  const vizioHeaderLogo = require('../assets/images/vizio-header-logo.png');
  const vizioHeaderLogoCaseNumber = require('../assets/images/vizio-header-logo-case-number.png');
  const equifaxHeader = require('../assets/images/equifax-header.png');
  const abDataFavicon = require('../assets/images/abdata_favicon.ico');
  const abDataLogo = require('../assets/images/abdata_logo.png');
  const garvinHeader = require('../assets/images/garvin_paywall.dc02e8.png');
  const epiqFavicon = require('../assets/images/epiq_favicon.ico');
  const shutterflyHeaderLogo = require('../assets/images/labaton-abdata-logo-cropped.png');
  const cTAGOheaderLogo = require('../assets/images/ct_ago_paywall.png');
  const ctAGOfavicon = require('../assets/images/ct_ago_favicon.ico');
  const propaneCaseLogo = require('../assets/images/propanetank_paywall.png');
  const milkCowLogo = require('../assets/images/milk-cow-logo.png');
  const milkFullHeader = require('../assets/images/milk-full-header.png');
  const milkGrassFooter = require('../assets/images/milk-grass-footer.png');
  const milkFavicon = require('../assets/images/milk-favicon.ico');
  const milkPaymentCompleteLogo = require('../assets/images/milk-payment-complete.png');
  const milkPaywallHeader = require('../assets/images/milk_header.png');
  const milkEmailHeader = require('../assets/images/milk-email-header.png');
  const milkShortHeader = require('../assets/images/milk_short_header.png');
  const awlHeaderLogo = require('../assets/images/awl-paywall-header.png');
  const abdataHeader = require('../assets/images/abdata-paywall-header.png');
  const oddPaywallLogo = require('../assets/images/odd-paywall-logo.png');
  const oddFavicon = require('../assets/images/odd_favicon.png');
  const oddFavicon2 = require('../assets/images/odd_favicon_2.png');
  const batteriesEmailHeader = require('../assets/images/batteries-email-header.png');
  const epiPenPaywallHeaderLogo = require('../assets/images/epipen-paywall-header-logo.png');
  const epiPenEmailHeaderLogo = require('../assets/images/epipen-email-header-black.png');
  const epiPenFavicon = require('../assets/images/epipen-favicon.png');
  const batteriesPaywallHeader = require('../assets/images/batteries-paywall-header.png');
  const batteriesFavicon = require('../assets/images/batteries-favicon.png');
  const sunCountryHeader = require('../assets/images/sun-country-header.png');
  const sunCountryFavicon = require('../assets/images/sun-country-favicon.ico')
  const ohioElectricLogo = require('../assets/images/oel_logo_paywall.png');
  const ohioElectricFavicon = require('../assets/images/oel_favicon.png');
  const dpLogoColor = require('../assets/images/dp-logo-new.png');
  const dpLogoWhite = require('../assets/images/dp-logo-new-white.png');
  const dpFavicon = require('../assets/images/dp-favicon-new.ico');

})();

export const getImageSrcUrl = imagePath => {
  if(!imagePath) return '';
  // A webpack image loading optimization causes inlining if the image is small enough, this checks for type data in the import
  // inlining of images is disabled on build by passing the IMAGE_INLINE_SIZE_LIMIT=0 flag to the build command, but this is ignored when running the
  // webpack dev server with npm run start
  if(imagePath.substring(0, 5) === 'data:'){
    return imagePath;
  }

  // only reference CDN url once app is deployed, as assets are synced to S3 during travis build. alternatively,
  // run npm run build locally, source aws creds and run npm run cdnsync, and set DEPLOYMENT_ENVIRONMENT envar to 'DEV' to pull CDN assets
  return `${settings.environment.DEPLOYMENT_ENVIRONMENT === 'LOCAL' ? '' : settings.environment.PAYWALL_CDN_URL}${imagePath}`;
};
